export default "__VITE_ASSET__KI$AuVZd__"